import { createAsyncThunk } from '@reduxjs/toolkit'
import {
  createFiltersConfigMap,
  createQueryRequestParams,
  getInitialFiltersParams,
  getQueryUrlFromData,
  getTransformedFiltersConfig,
} from '@/common/utils/transformFilters'
import { setCookie } from 'cookies-next'
import { APPLIED_CREATIVES_FILTERS } from '@/common/constants/filtersFields'
import { LIMIT_CODE } from '@/common/constants/responseCodes'
import { open } from '@/store/modalsSlice'
import { LIMIT_MODAL } from '@/common/constants/modals'

export const fetchFiltersConfig = createAsyncThunk(
  'fetchFiltersConfig',
  async ({ token, filtersConfigRequest, sliceName }, { rejectWithValue }) => {
    try {
      const config = await filtersConfigRequest(token)
      const transformedFiltersConfig = getTransformedFiltersConfig(config)
      const filtersConfigMap = createFiltersConfigMap(transformedFiltersConfig)
      const initialParams = getInitialFiltersParams(transformedFiltersConfig)

      return {
        config,
        transformedFiltersConfig,
        filtersConfigMap,
        initialParams,
        sliceName,
      }
    } catch (e) {
      return rejectWithValue(e)
    }
  }
)

export const fetchAdsThunk = (name, setAds) => {
  return createAsyncThunk(
    `${name}/fetchAds`,
    async (
      {
        withInfiniteScroll = false,
        request,
        params = {},
        itemsName = 'advertisements',
        isUpdateCookieFilters,
        signal,
      },
      { rejectWithValue, dispatch, getState }
    ) => {
      try {
        if (!withInfiniteScroll) {
          dispatch(setAds([]))
        }

        const filters = getState()[name].filtersParams

        const queryMap = {
          ...params,
          ...createQueryRequestParams(filters),
        }
        const query = getQueryUrlFromData(queryMap)

        if (isUpdateCookieFilters) {
          setCookie(APPLIED_CREATIVES_FILTERS, query)
        }

        const { creativeIdentical } = query
        const { [itemsName]: items, pagination } = await request(
          queryMap,
          signal
        )

        const modifiedCreatives = items.map((item) => ({
          ...item,
          isTranslate: false,
        }))

        return {
          items: modifiedCreatives,
          pagination: pagination || { pages: {}, results: {} },
          withInfiniteScroll: withInfiniteScroll,
          isVisibleFilters: !creativeIdentical,
        }
      } catch (e) {
        const headers = e?.response?.headers ?? {}
        const error = e.data?.error ?? {}
        const response = e.response ?? {}

        if (error?.code === LIMIT_CODE) {
          await dispatch(open(LIMIT_MODAL))
        }

        return rejectWithValue({ ...headers, ...error, ...response })
      }
    }
  )
}
